import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class KahpooCommissionService {

  constructor(private http: HttpClient) { }


  getAllKahpooCommission(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/kahpoocommission`+ (size ? '?page=' + page + '&size=' + size : ''));
  }

  getAllCommissionsByDates(sessionId: string, startDate: string, endDate: string, page: number = 0, size: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('page', page.toString())
      .set('size', size.toString())

    const headers = {
      'kapo_session_id': sessionId,
    };

    return this.http.get(`${environment.url}/kahpoocommission`, { params, headers });
  }

  getAllCommissionsBySearchValue(sessionId: string, searchValue: string): Observable<any> {
    const params = new HttpParams().set('searchValue', searchValue);

    const headers = new HttpHeaders({
      'kapo_session_id': sessionId,
    });

    return this.http.get(`${environment.url}/kahpoocommission`, { params, headers });
  }

  searchKahpooPost_1(searchText: string) : Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/v1/kahpoocommission?fields=kahpoocommission,orderitem&postSearchText=${searchText}`,{'headers': headers});
  }

  getTototal(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/kahpoocommission/alltotal`, { headers });
  }

  getTototalBeetwenDate(sessionId: string, startDate: string, endDate: string): Observable<any> {
    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate)
    const headers = {
      'kapo_session_id': sessionId,
    };

    return this.http.get(`${environment.url}/kahpoocommission/total`, { params, headers });
  }

}
